import StickyModal from './stickyModal';

(function (Drupal, once) {
  Drupal.behaviors.stickyModal = {
    attach: (context) => {
      const elements = once('stickyModal', '[data-js-sticky-modal="true"]', context);

      // Store the initialized instances
      const modalInstances = elements.map((el) => StickyModal.init(el));

      const opener = once('stickyModalOpener', '.sticky-modal__opener', context);
      opener.forEach(function (el) {
        el.addEventListener("click", function () {
          // Use the first instance from modalInstances
          if (modalInstances.length > 0) {
            modalInstances[0].showModal();
          }
        });
      });
    },
  };
})(Drupal, once);

